module.exports = __webpack_public_path__ + "static/media/b31@2x.b0121d7c.png";